import React from 'react';
import { isNil } from 'lodash';
import { Button, FilterFunnel02Icon } from '@metarouter-private/mr-mui';
import WithTooltip from 'app/components/WithTooltip';
import { useDrawerContext } from 'app/shared/contexts/drawer';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';
import TRANSFORMATION_DRAWERS from 'app/pipeline-details/PipelineTransformationsSection/PipelineTransformationsDrawer/TRANSFORMATION_DRAWERS';

const DISABLED_MESSAGE = 'No filters configured. Currently only configurable through the CLI.';

export default function PipelineFiltersButton() {
  const { pipeline } = usePipelinePageContext();
  const { launchDrawer } = useDrawerContext();
  const deployedFilter = pipeline.deployedPipeline?.filter;

  const onClick = () => {
    launchDrawer({
      drawer: TRANSFORMATION_DRAWERS.PIPELINE_FILTERS,
      filter: deployedFilter,
    });
  };

  const disabled = isNil(deployedFilter);

  return (
    <WithTooltip show={disabled} title={DISABLED_MESSAGE}>
      <Button
        variant="outlined"
        size="medium"
        color="secondary"
        startIcon={<FilterFunnel02Icon />}
        onClick={onClick}
        disabled={disabled}
      >
        Pipeline Filters
      </Button>
    </WithTooltip>
  );
}
